const getters = {
  listaVinculosDocumento: (state) => state.listaVinculosDocumento,
  documentoAgregador: (state) => state.documentoAgregador
}

export default getters
